<template>
  <div class="container min-h-screen pt-24 px-2 md:px-0">
    <div class="pt-4 pb-2 mb-4 border-b border-gray-400">
      <h1 class="text-xl font-bold">Compliance</h1>
    </div>
    <div>
      <p class="pb-3 text-gray-800">
        VIVA Finance holds the State consumer lending licenses and registrations shown below.
      </p>
      <div class="flex flex-col items-center justify-center dashboard-card card-shadow p-0">
        <div class="flex items-center justify-center viva-green w-full py-2 compliance-card">
          <div class="w-1/4 flex items-center justify-center">
            <h1 class="text-white text-center md:text-lg">State</h1>
          </div>
          <div class="w-1/4 flex items-center justify-center">
            <h1 class="text-white text-center md:text-lg">License</h1>
          </div>
          <div class="w-1/4 flex items-center justify-center">
            <h1 class="text-white text-center md:text-lg">License Type</h1>
          </div>
          <div class="w-1/4 flex items-center justify-center">
            <h1 class="text-white text-center md:text-lg">Entity</h1>
          </div>
        </div>
        <div
          v-for="state in states"
          v-bind:key="state.license"
          class="flex items-center justify-center bg-white p-1 w-full border-b"
        >
          <div class="w-1/4 flex items-center justify-center">
            <h1>{{ state.name }}</h1>
          </div>
          <div class="w-1/4 flex items-center justify-center">
            <h1>
              <a
                :href="state.link"
                rel="noreferrer"
                target="_blank"
                class="text-blue-500 hover:text-blue-400"
              >
                {{ state.license }}
              </a>
            </h1>
          </div>
          <div class="w-1/4 flex items-center text-center justify-center">
            <h1>{{ state.type }}</h1>
          </div>
          <div class="w-1/4 flex items-center justify-center">
            <h1>{{ state.entity }}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      states: [
        {
          name: 'Alabama',
          license: 'MC 22673',
          type: 'Consumer Credit License',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Alabama+Consumer+Credit+License+.pdf'
        },
        {
          name: 'Alabama',
          license: 'SL 22674',
          type: 'Small Loan License',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Alabama+Small+Loan+License.pdf'
        },
        {
          name: 'Arizona',
          license: 'CL - 1021645',
          type: 'Consumer Lender',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Arizona+Consumer+Lender+License+.pdf'
        },
        {
          name: 'California',
          license: '60DBO-127301',
          type: 'Finance Lender',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/californiaLicense.pdf'
        },
        {
          name: 'Florida',
          license: 'CF9901424',
          type: 'Consumer Finance Company',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Florida+Consumer+Finance+Company+License.pdf'
        },
        {
          name: 'Georgia',
          license: '30666',
          type: 'Georgia Industrial Loan License',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Georgia+Industrial+Loan+License.pdf'
        },
        {
          name: 'Illinois',
          license: '0004696 - H',
          type: 'Illinois Consumer Installment Loan License',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Illinois+Consumer+Installment+Loan+License+.pdf'
        },
        {
          name: 'Kentucky',
          license: 'CL751552',
          type: 'Kentucky Consumer Loan Company',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Kentucky+Consumer+Loan+Company+License+.pdf'
        },
        {
          name: 'Louisiana',
          license: 'NMLS#1905666',
          type: 'Louisiana Licensed Lender',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Louisiana+Licensed+Lender+License.pdf'
        },
        {
          name: 'Maryland',
          license: 'NMLS#1905666',
          type: 'Consumer Loan License',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/MarylandLicense2022.pdf'
        },
        {
          name: 'Michigan',
          license: 'RL0023463',
          type: 'Michigan Regulatory Loan License',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Michigan+Regulatory+Loan+License.pdf'
        },
        {
          name: 'Missouri',
          license: '510-22-9134',
          type: 'Consumer Installment Lender Company',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/MissouriLicense2022.pdf'
        },
        {
          name: 'New Mexico',
          license: '02347',
          type: 'Small Loan Company License',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/New+Mexico.pdf'
        },
        {
          name: 'Oklahoma',
          license: 'SL008771',
          type: 'Supervised Lender License',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/OklahomaLicense.pdf'
        },
        {
          name: ' South Carolina',
          license: 'SL – 1905666',
          type: 'South Carolina-BFI Supervised Lender',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/South+Carolina+Supervised+Lender(SL)+License+.pdf'
        },
        {
          name: ' South Carolina',
          license: 'SLW1 - 1905666',
          type: 'South Carolina-BFI Supervised Lender',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/South+Carolina+Supervised+Lender(SLW1)+License+.pdf'
        },
        {
          name: 'Tennessee',
          license: '203161',
          type: 'Industrial Loan and Thrift Company',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Tennessee+Industrial+Loan+and+Thrift+Company+License+.pdf'
        },
        {
          name: 'Texas',
          license: '1900064870-163173',
          type: 'Regulated Lender License',
          entity: 'Viva Finance Inc',
          link: 'https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Texas+Regulated+Lender+License.pdf'
        }
      ]
    }
  },

  methods: {}
}
</script>

<style scoped>
.compliance-card {
  -webkit-border-top-left-radius: 5px;
  -webkit-border-top-right-radius: 5px;
  -moz-border-radius-topleft: 5px;
  -moz-border-radius-topright: 5px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
</style>
